import React from "react";
import Footer from "../../app/landing/Footer";
import { LogoIcon } from "../../design-system";
import { APP_DOMAIN } from '../../core/utils/config';
import { logoFontStyle } from "../../design-system/brand/logoFont";
import { NetworkErrorState } from "../../design-system/components/layouts";

const ErrorWebsite = ({ username, domain, error = "", onRetry = null, showFooter = true }) => {
  const filteredUsername = username ? username : "";
  const filteredDomain = domain ? domain : "";
  const usernameAndDomain = [filteredUsername, filteredDomain]
    .filter(Boolean)
    .join("/");

  const isNetworkError =
    typeof error === "string" && error.toLowerCase().includes("network error");

  const message = usernameAndDomain
    ? `Website "${usernameAndDomain}" had an issue loading`
    : "Website had an issue loading";

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center text-blue-800 p-8">
        {/* Logo */}
        <div className="mb-8">
          <LogoIcon className="w-24 h-24" color="#60a5fa" />
        </div>

        {/* myvitae.ai Branding */}
        <div className="mb-8 text-center">
          <a href="/" className="inline-block">
            <h1 className="text-6xl sm:text-7xl font-bold text-blue-600 mb-2" style={logoFontStyle}>
              {APP_DOMAIN}<sup className="text-3xl">®</sup>
            </h1>
          </a>
        </div>

        {/* Error Message */}
        <div className="text-center max-w-2xl">
          {isNetworkError ? (
            <NetworkErrorState
              title="Network error :("
              description="We couldn't load this website right now. Please check your connection and try again."
              onRetry={
                typeof onRetry === "function"
                  ? onRetry
                  : () => {
                      try {
                        window.location.reload();
                      } catch (_) {}
                    }
              }
              className="py-2"
            />
          ) : (
            <>
              <h2 className="font-heading text-3xl sm:text-4xl font-bold text-blue-600 mb-6">{message}</h2>
              <p className="text-xl text-gray-600 leading-relaxed">
                We are already aware of the issue and are working to resolve it. Please,
                check back soon!
              </p>
            </>
          )}
        </div>
      </div>

      {showFooter && <Footer />}
    </div>
  );
};

export default ErrorWebsite;
